import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { addSurveyToSurveyBank, AddSurveyToSurveyBankProps } from ".";

export function useAddSurveyToSurveyBank(){
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: queryKeys.survey_bank._def,
        mutationFn: addSurveyToSurveyBank,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.survey_bank._def, exact: false });
        }
    });
}
